import styled from 'styled-components';

export interface LegalInfoPanelProps {
  className?: string;
}

const Heading = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  line-height: 19px;
  color: ${({ theme }) => theme.colors.GREY};
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  &:after {
    content: '';
    display: block;
    padding-top: ${({ theme }) => theme.spacing.S8};
    border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_LIGHT};
  }
`;

const SubText = styled.p`
  ${({ theme }) => theme.fontSize.S12};
  line-height: 15px;
  color: ${({ theme }) => theme.colors.GREY};
`;

function LegalInfoPanel({ className }: LegalInfoPanelProps) {
  return (
    <div className={className}>
      <Heading>Legal</Heading>
      <SubText>
        DoneDeal.ie is not responsible for the advertised goods. It is illegal
        to use the contact information for commercial purposes.
      </SubText>
    </div>
  );
}

export { LegalInfoPanel };
